import { DbTable } from '../db-table';
import { User } from '../../../../core/auth';
import { HttpClient } from '@angular/common/http';
import { Order, Product } from '../../../../core/_shared/models/product';
import { RelOrderScheme } from "../../../../core/_shared/models/RelOrderScheme";
import {  httpOptionsDefault } from '../../../_shared/constants';
import { map } from 'rxjs/operators';
import { CreditCardModel, PersonalDataModel } from '../../../_shared/models/credit-card.model';
import { WebApiService } from '../../WebApiService';

export class DbUsers extends DbTable<User> {


    constructor(private http: HttpClient,private webApi:WebApiService) {
        super(http,webApi, "Users");
    }

    getCreditCardListCurrentUser()
    {
        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/getCreditCards`)
        .pipe(
            map((result: any[]) => {
                // let list: T[] = result.json();
                // console.log(list);
                return result;

            })).toPromise();
    } 
    

    getPersonalDataCurrentUser(): Promise<PersonalDataModel> {
        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/getPersonalData`)
        .pipe(
            map((result: PersonalDataModel) => {
                return result;

            })).toPromise();
      }


    getCreditCardCurrentUser(): Promise<CreditCardModel>
    {
        return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/getCreditCard`)
        .pipe(
            map((result: CreditCardModel) => {
                // let list: T[] = result.json();
                // console.log(list);
                return result;

            })).toPromise();
    } 

    setPersonalDataCurrentUser(personalData: PersonalDataModel): any {


        return this._http.post(this._webApi.GetApiAddress() + `/${this._controllerName}/setPersonalData`,personalData,httpOptionsDefault)
        .pipe(
            map((result: any) => {
          
                return result;

            })).toPromise();
  }


    setCreditCardCurrentUser(creditCard: CreditCardModel): any {


        return this._http.post(this._webApi.GetApiAddress() + `/${this._controllerName}/setCreditCard`,creditCard,httpOptionsDefault)
        .pipe(
            map((result: any) => {
                 console.log(result);
                return result;

            })).toPromise();
  }
}


 export class DbOrders extends DbTable<Order> {

        constructor(private http: HttpClient,private webApi:WebApiService) {
            super(http,webApi, "orders");
        }



        public getListByScheme(schemeId:number): Promise<Order[]> {

         
            return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/scheme/${schemeId}`)
                .pipe(
                    map((result: Order[]) => {
               
                        return result;
    
                    })).toPromise();
        }

        public getProductsList(orderId:number|string): Promise<Product[]> {

         
            return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/${orderId}/products`)
                .pipe(
                    map((result: Product[]) => {
               
                        return result;
    
                    })).toPromise();
        }

        public getRelScheme(orderId:number|string): Promise<RelOrderScheme> {

         
            return this._http.get(this._webApi.GetApiAddress() + `/${this._controllerName}/${orderId}/relScheme`)
                .pipe(
                    map((result: RelOrderScheme) => {
               
                        return result;
    
                    })).toPromise();
        }

    }

